import { render } from "./JourneyCard.vue?vue&type=template&id=28660269&scoped=true&lang=pug"
import script from "./JourneyCard.vue?vue&type=script&lang=ts"
export * from "./JourneyCard.vue?vue&type=script&lang=ts"

import "./JourneyCard.vue?vue&type=style&index=0&id=28660269&lang=scss&scoped=true"
import "./JourneyCard.vue?vue&type=style&index=1&id=28660269&lang=scss"
script.render = render
script.__scopeId = "data-v-28660269"

export default script